// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../rescript/lib/es6/curry.js";
import * as Json__Decode from "../../../../rescript-json/lib/es6_global/src/Json__Decode.bs.js";
import * as Generic$ApiTypes from "./utils/Generic.bs.js";
import * as ProductDetailsConfigId$ApiTypes from "./ProductDetailsConfigId.bs.js";
import * as ProductRuleConfigCodecs$ApiTypes from "./ProductRuleConfigCodecs.bs.js";

var productData_fromJson = Generic$ApiTypes.Decode.simpleVariant([
      [
        "ProductTitle",
        /* ProductTitle */0
      ],
      [
        "ProductDescription",
        /* ProductDescription */1
      ],
      [
        "ProductPrice",
        /* ProductPrice */2
      ],
      [
        "ProductSalePrice",
        /* ProductSalePrice */3
      ],
      [
        "ProductSKU",
        /* ProductSKU */4
      ],
      [
        "ProductId",
        /* ProductId */5
      ],
      [
        "VariantId",
        /* VariantId */6
      ]
    ]);

var availability_fromJson = Json__Decode.map2(Json__Decode.field("inStockText", Json__Decode.string), Json__Decode.field("outOfStockText", Json__Decode.string), (function (inStockText, outOfStockText) {
        return {
                inStockText: inStockText,
                outOfStockText: outOfStockText
              };
      }));

var source_fromJson = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("ProductData", productData_fromJson, (function (value) {
            return {
                    TAG: /* ProductData */0,
                    _0: value
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("MetaData", Json__Decode.string, (function (value) {
              return {
                      TAG: /* MetaData */1,
                      _0: value
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("CustomLabel", Json__Decode.$$int, (function (value) {
              return {
                      TAG: /* CustomLabel */2,
                      _0: value
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("Availability", availability_fromJson, (function (value) {
              return {
                      TAG: /* Availability */3,
                      _0: value
                    };
            }))
    ]);

var fromJson = Curry._5(Generic$ApiTypes.Decode.map4, Curry._2(Generic$ApiTypes.Decode.field, "id", ProductDetailsConfigId$ApiTypes.ContentId.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "source", source_fromJson), Curry._2(Generic$ApiTypes.Decode.field, "isRichText", Generic$ApiTypes.Decode.bool), Generic$ApiTypes.Decode.fieldWithDefault("isPreWrapped", Generic$ApiTypes.Decode.bool, false), (function (id, source, isRichText, isPreWrapped) {
        return {
                id: id,
                source: source,
                isRichText: isRichText,
                isPreWrapped: isPreWrapped
              };
      }));

var DynamicSource = {
  productData_fromJson: productData_fromJson,
  metaData_fromJson: Json__Decode.string,
  customLabel_fromJson: Json__Decode.$$int,
  availability_fromJson: availability_fromJson,
  source_fromJson: source_fromJson,
  fromJson: fromJson
};

var source_fromJson$1 = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("URL", Generic$ApiTypes.Decode.string, (function (url) {
            return {
                    TAG: /* URL */0,
                    _0: url
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("MetaData", Generic$ApiTypes.Decode.string, (function (m) {
              return {
                      TAG: /* MetaData */1,
                      _0: m
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("CustomLabel", Generic$ApiTypes.Decode.$$int, (function (c) {
              return {
                      TAG: /* CustomLabel */2,
                      _0: c
                    };
            }))
    ]);

var altTextSource_fromJson = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("Text", Generic$ApiTypes.Decode.string, (function (u) {
            return {
                    TAG: /* Text */0,
                    _0: u
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("MetaData", Generic$ApiTypes.Decode.string, (function (m) {
              return {
                      TAG: /* MetaData */1,
                      _0: m
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("CustomLabel", Generic$ApiTypes.Decode.$$int, (function (c) {
              return {
                      TAG: /* CustomLabel */2,
                      _0: c
                    };
            }))
    ]);

var fromJson$1 = Json__Decode.map3(Json__Decode.field("id", ProductDetailsConfigId$ApiTypes.ContentId.fromJson), Json__Decode.field("source", source_fromJson$1), Json__Decode.field("altText", Json__Decode.option(altTextSource_fromJson)), (function (id, source, altText) {
        return {
                id: id,
                source: source,
                altText: altText
              };
      }));

var $$Image = {
  source_fromJson: source_fromJson$1,
  altTextSource_fromJson: altTextSource_fromJson,
  fromJson: fromJson$1
};

var fromJson$2 = Curry._5(Generic$ApiTypes.Decode.map4, Curry._2(Generic$ApiTypes.Decode.field, "id", ProductDetailsConfigId$ApiTypes.ContentId.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "text", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "isRichText", Generic$ApiTypes.Decode.bool), Generic$ApiTypes.Decode.fieldWithDefault("isPreWrapped", Generic$ApiTypes.Decode.bool, false), (function (id, text, isRichText, isPreWrapped) {
        return {
                id: id,
                text: text,
                isRichText: isRichText,
                isPreWrapped: isPreWrapped
              };
      }));

var $$Text = {
  fromJson: fromJson$2
};

var fromJson$3 = Json__Decode.map(Json__Decode.field("id", ProductDetailsConfigId$ApiTypes.ContentId.fromJson), (function (id) {
        return {
                id: id
              };
      }));

var Enhance = {
  fromJson: fromJson$3
};

var cellContent_fromJson = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("DynamicSource", fromJson, (function (u) {
            return {
                    TAG: /* DynamicSource */0,
                    _0: u
                  };
          })), [Generic$ApiTypes.Decode.deccoVariantWithPayload("Text", fromJson$2, (function (m) {
              return {
                      TAG: /* Text */1,
                      _0: m
                    };
            }))]);

var style_fromJson = Generic$ApiTypes.Decode.simpleVariant([
      [
        "BasicTable",
        /* BasicTable */0
      ],
      [
        "HorizontallyScrollableTable",
        /* HorizontallyScrollableTable */1
      ],
      [
        "NoBordersTable",
        /* NoBordersTable */2
      ]
    ]);

var fromJson$4 = Curry._4(Generic$ApiTypes.Decode.map3, Curry._2(Generic$ApiTypes.Decode.field, "id", ProductDetailsConfigId$ApiTypes.ContentId.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "cells", Curry._1(Generic$ApiTypes.Decode.array, Curry._1(Generic$ApiTypes.Decode.array, cellContent_fromJson))), Generic$ApiTypes.Decode.fieldWithDefault("style", style_fromJson, /* BasicTable */0), (function (id, cells, style) {
        return {
                id: id,
                cells: cells,
                style: style
              };
      }));

var Table = {
  cellContent_fromJson: cellContent_fromJson,
  style_fromJson: style_fromJson,
  fromJson: fromJson$4
};

var fromJson$5 = Curry._3(Generic$ApiTypes.Decode.map2, Curry._2(Generic$ApiTypes.Decode.field, "id", ProductDetailsConfigId$ApiTypes.ContentId.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "code", Generic$ApiTypes.Decode.string), (function (id, code) {
        return {
                id: id,
                code: code
              };
      }));

var Code = {
  fromJson: fromJson$5
};

var fromJson$6 = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.deccoVariantWithPayload("DynamicSource", fromJson, (function (u) {
            return {
                    TAG: /* DynamicSource */0,
                    _0: u
                  };
          })), [
      Generic$ApiTypes.Decode.deccoVariantWithPayload("Text", fromJson$2, (function (m) {
              return {
                      TAG: /* Text */1,
                      _0: m
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("Image", fromJson$1, (function (c) {
              return {
                      TAG: /* Image */2,
                      _0: c
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("Enhance", fromJson$3, (function (c) {
              return {
                      TAG: /* Enhance */3,
                      _0: c
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("Table", fromJson$4, (function (c) {
              return {
                      TAG: /* Table */4,
                      _0: c
                    };
            })),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("JavaScript", fromJson$5, (function (c) {
              return {
                      TAG: /* JavaScript */5,
                      _0: c
                    };
            }))
    ]);

var Content = {
  DynamicSource: DynamicSource,
  $$Image: $$Image,
  $$Text: $$Text,
  Enhance: Enhance,
  Table: Table,
  Code: Code,
  fromJson: fromJson$6
};

var t_v2_decode = Curry._2(Generic$ApiTypes.Decode.oneOf, Generic$ApiTypes.Decode.simpleVariant([[
            "Visible",
            /* Visible */0
          ]]), [
      Generic$ApiTypes.Decode.simpleVariant([[
              "Hidden",
              /* Hidden */1
            ]]),
      Generic$ApiTypes.Decode.deccoVariantWithPayload("RuleBased", ProductRuleConfigCodecs$ApiTypes.fromJson(undefined), (function (rule) {
              return /* RuleBased */{
                      _0: rule
                    };
            }))
    ]);

var t_v1_decode = Curry._2(Generic$ApiTypes.Decode.andThen, Generic$ApiTypes.Decode.$$default(Generic$ApiTypes.Decode.bool, true), (function (visible) {
        return Curry._1(Generic$ApiTypes.Decode.succeed, visible ? /* Visible */0 : /* Hidden */1);
      }));

var t_decode = Json__Decode.oneOf(t_v2_decode, [t_v1_decode]);

var Visible = {
  t_v2_decode: t_v2_decode,
  t_v1_decode: t_v1_decode,
  t_decode: t_decode,
  fromJson: t_decode
};

var fromJson$7 = Curry._6(Generic$ApiTypes.Decode.map5, Curry._2(Generic$ApiTypes.Decode.field, "id", ProductDetailsConfigId$ApiTypes.SectionId.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "content", fromJson$6), Curry._2(Generic$ApiTypes.Decode.field, "title", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "iconUrl", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "visible", t_decode), (function (id, content, title, iconUrl, visible) {
        return {
                id: id,
                content: content,
                title: title,
                iconUrl: iconUrl,
                visible: visible
              };
      }));

var SummarySection = {
  fromJson: fromJson$7
};

var accordionState_fromJson = Generic$ApiTypes.Decode.simpleVariant([
      [
        "DefaultState",
        /* DefaultState */0
      ],
      [
        "AlwaysExpandedState",
        /* AlwaysExpandedState */1
      ]
    ]);

var fromJson$8 = Curry._7(Generic$ApiTypes.Decode.map6, Curry._2(Generic$ApiTypes.Decode.field, "id", ProductDetailsConfigId$ApiTypes.SectionId.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "contents", Curry._1(Generic$ApiTypes.Decode.array, fromJson$6)), Generic$ApiTypes.Decode.fieldWithDefault("accordionState", accordionState_fromJson, /* DefaultState */0), Curry._2(Generic$ApiTypes.Decode.field, "title", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "iconUrl", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "visible", t_decode), (function (id, contents, accordionState, title, iconUrl, visible) {
        return {
                id: id,
                contents: contents,
                accordionState: accordionState,
                title: title,
                iconUrl: iconUrl,
                visible: visible
              };
      }));

var DetailedSection = {
  accordionState_fromJson: accordionState_fromJson,
  fromJson: fromJson$8
};

var fromJson$9 = Curry._5(Generic$ApiTypes.Decode.map4, Curry._2(Generic$ApiTypes.Decode.field, "id", ProductDetailsConfigId$ApiTypes.SectionId.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "contents", Curry._1(Generic$ApiTypes.Decode.array, fromJson$6)), Curry._2(Generic$ApiTypes.Decode.field, "title", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "visible", t_decode), (function (id, contents, title, visible) {
        return {
                id: id,
                contents: contents,
                title: title,
                visible: visible
              };
      }));

var PromoSection = {
  fromJson: fromJson$9
};

var fromJson$10 = Curry._7(Generic$ApiTypes.Decode.map6, Curry._2(Generic$ApiTypes.Decode.field, "id", ProductDetailsConfigId$ApiTypes.SectionId.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "content", fromJson$6), Curry._2(Generic$ApiTypes.Decode.field, "mobileContent", Curry._1(Generic$ApiTypes.Decode.option, fromJson$6)), Curry._2(Generic$ApiTypes.Decode.field, "title", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "visible", t_decode), Generic$ApiTypes.Decode.fieldWithDefault("showTitle", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.bool), undefined), (function (id, content, mobileContent, title, visible, showTitle) {
        return {
                id: id,
                content: content,
                mobileContent: mobileContent,
                title: title,
                visible: visible,
                showTitle: showTitle
              };
      }));

var EnhanceSection = {
  fromJson: fromJson$10
};

var fromJson$11 = Curry._7(Generic$ApiTypes.Decode.map6, Curry._2(Generic$ApiTypes.Decode.field, "id", ProductDetailsConfigId$ApiTypes.SectionId.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "content", fromJson$6), Curry._2(Generic$ApiTypes.Decode.field, "visible", t_decode), Curry._2(Generic$ApiTypes.Decode.field, "title", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "backgroundColor", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "textColor", Generic$ApiTypes.Decode.string), (function (id, content, visible, title, backgroundColor, textColor) {
        return {
                id: id,
                content: content,
                title: title,
                visible: visible,
                backgroundColor: backgroundColor,
                textColor: textColor
              };
      }));

var Badge = {
  fromJson: fromJson$11
};

var fromJson$12 = Curry._5(Generic$ApiTypes.Decode.map4, Curry._2(Generic$ApiTypes.Decode.field, "id", ProductDetailsConfigId$ApiTypes.SectionId.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "title", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "visible", t_decode), Curry._2(Generic$ApiTypes.Decode.field, "content", fromJson$6), (function (id, title, visible, content) {
        return {
                id: id,
                title: title,
                visible: visible,
                content: content
              };
      }));

var ReviewSection = {
  fromJson: fromJson$12
};

function showAs_toJson(showAs) {
  if (showAs) {
    return Generic$ApiTypes.Encode.simpleVariant([[
                  "Suffix",
                  /* Suffix */1
                ]], /* Suffix */1);
  } else {
    return Generic$ApiTypes.Encode.simpleVariant([[
                  "Prefix",
                  /* Prefix */0
                ]], /* Prefix */0);
  }
}

var showAs_fromJson = Generic$ApiTypes.Decode.simpleVariant([
      [
        "Prefix",
        /* Prefix */0
      ],
      [
        "Suffix",
        /* Suffix */1
      ]
    ]);

var fromJson$13 = Curry._7(Generic$ApiTypes.Decode.map6, Curry._2(Generic$ApiTypes.Decode.field, "id", ProductDetailsConfigId$ApiTypes.SectionId.fromJson), Curry._2(Generic$ApiTypes.Decode.field, "title", Generic$ApiTypes.Decode.string), Curry._2(Generic$ApiTypes.Decode.field, "visible", t_decode), Curry._2(Generic$ApiTypes.Decode.field, "visibleInProductCard", Generic$ApiTypes.Decode.bool), Curry._2(Generic$ApiTypes.Decode.field, "content", fromJson$6), Curry._2(Generic$ApiTypes.Decode.field, "showAs", showAs_fromJson), (function (id, title, visible, visibleInProductCard, content, showAs) {
        return {
                id: id,
                title: title,
                visible: visible,
                visibleInProductCard: visibleInProductCard,
                showAs: showAs,
                content: content
              };
      }));

var PriceLabel = {
  showAs_toJson: showAs_toJson,
  showAs_fromJson: showAs_fromJson,
  fromJson: fromJson$13
};

var fromJson$14 = Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._1(Generic$ApiTypes.Decode.succeed, (function (summarySections, detailedSections, promoSection, promoSections, enhanceSection, enhanceSections, badges, reviews, priceLabels) {
                                            return {
                                                    summarySections: summarySections,
                                                    detailedSections: detailedSections,
                                                    promoSection: promoSection,
                                                    promoSections: promoSections,
                                                    enhanceSection: enhanceSection,
                                                    enhanceSections: enhanceSections,
                                                    badges: badges,
                                                    reviews: reviews,
                                                    priceLabels: priceLabels
                                                  };
                                          })), Curry._2(Generic$ApiTypes.Decode.field, "summarySections", Curry._1(Generic$ApiTypes.Decode.array, fromJson$7))), Curry._2(Generic$ApiTypes.Decode.field, "detailedSections", Curry._1(Generic$ApiTypes.Decode.array, fromJson$8))), Curry._2(Generic$ApiTypes.Decode.field, "promoSection", fromJson$9)), Curry._2(Generic$ApiTypes.Decode.field, "promoSections", Curry._1(Generic$ApiTypes.Decode.array, fromJson$9))), Curry._2(Generic$ApiTypes.Decode.field, "enhanceSection", Curry._1(Generic$ApiTypes.Decode.option, fromJson$10))), Curry._2(Generic$ApiTypes.Decode.field, "enhanceSections", Curry._1(Generic$ApiTypes.Decode.array, fromJson$10))), Curry._2(Generic$ApiTypes.Decode.field, "badges", Curry._1(Generic$ApiTypes.Decode.array, fromJson$11))), Curry._2(Generic$ApiTypes.Decode.field, "reviews", Curry._1(Generic$ApiTypes.Decode.array, fromJson$12))), Curry._2(Generic$ApiTypes.Decode.field, "priceLabels", Curry._1(Generic$ApiTypes.Decode.array, fromJson$13)));

export {
  Content ,
  Visible ,
  SummarySection ,
  DetailedSection ,
  PromoSection ,
  EnhanceSection ,
  Badge ,
  ReviewSection ,
  PriceLabel ,
  fromJson$14 as fromJson,
}
/* productData_fromJson Not a pure module */
